import { e2p } from "../utils";
import MyImage from "./common/MyImage";

const LeaderboardItem = ({ rank, score, title, singer, cover }: any) => {
  return (
    <div className="flex items-center gap-3 sm:gap-4 relative w-full">
      {/* تصویر آهنگ */}
      <div className="w-[35%] aspect-square relative rounded-md">
        <MyImage src={cover} alt={title} className="size-full object-cover rounded-md" />

        {/* رتبه */}
        <span className="absolute font-bold text-sm sm:text-base top-0 -left-4 sm:-left-6 size-7 sm:size-9 z-10 text-white rounded-md bg-[#2a95db] flex items-center justify-center">
          {e2p(`${rank}`)}
        </span>
      </div>

      {/* اطلاعات آهنگ */}
      <div className="flex flex-col justify-center flex-1 text-right mt-7">
        <span className="font-semibold text-sm sm:text-base leading-tight line-clamp-1">
          {title}
        </span>
        <span className="text-sm text-black leading-tight line-clamp-1">
          {singer}
        </span>
      </div>

      {/* امتیاز */}
      <div className="flex items-center gap-1 sm:gap-2 absolute left-2 top-0">
        <span className="text-sm sm:text-lg font-bold text-[#f54f02]">
          {e2p(`${score}`)}
        </span>
        <img alt="star" src="/images/star.svg" className="w-4 sm:w-5 h-4 sm:h-5" />
      </div>
    </div>
  );
};

export default LeaderboardItem;
